/** Marks the heading focus moves to when a step opens. */
const STEP_HEADING_SELECTOR = "[data-lead-flow-step-heading]";

export { STEP_HEADING_SELECTOR };
